import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";

import { AuthService } from "@services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    return this.authService.isAuthenticated
      ? true
      : this.router.createUrlTree(["/login"]);
  }
}
